import React from "react";


const normalize = (value) => String(value || "").trim().toUpperCase();

export const getStatusMeta = (status) => {
  const v = normalize(status);

  const map = {
    SIGNED: { label: "Semnat", variant: "signed" },
    CONFIRMED: { label: "Confirmat", variant: "confirmed" },
    PENDING: { label: "În așteptare", variant: "pending" },
    REJECTED: { label: "Respins", variant: "rejected" },
    DRAFT: { label: "Ciornă", variant: "draft" },
    IN_PROGRESS: { label: "În lucru", variant: "in-progress" },
    COMPLETED: { label: "Finalizat", variant: "completed" },
    CANCELLED: { label: "Anulat", variant: "cancelled" },
  };

  return map[v] || { label: v || "-", variant: "default" };
};

export default function StatusBadge({
  status,
  className = "",
  withBorder = true,
}) {

  const { label, variant } = getStatusMeta(status);
  const v = normalize(status);
  const isConfirmed = v === "CONFIRMED";
  const cls = [
    "status-badge",
    `status-badge--${variant}`,
    withBorder ? "status-badge--border" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

   return (
    <span className={cls}>
      {isConfirmed ? (
        <div className="checkbox mini" style={{ cursor: "not-allowed" }}>
          <input type="checkbox" checked readOnly />
          <div className="checksquare" />
        </div>
      ) : null}
      {label}
    </span>
  );
}
